export const NUMBER_OF_INDICATORS = 7;
